import React from "react"
import { Button, Dropdown } from "antd"
import { MoreOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import styles from "../index.module.css"
import { Text } from "ui/Typography"
import EntryTypeTag, { isBlackout } from "../../../components/EntryTypeTag"

/**
 * Custom hook to generate table columns for scheduled time off
 * @param {Function} onEdit - Handler for edit action
 * @param {Function} onDelete - Handler for delete action
 * @returns {Array} Table column configuration
 */
const useScheduledTimeOffColumns = (onEdit, onDelete) => {
  const { t } = useTranslation()

  const columns = [
    {
      title: t("crewMember.scheduledTimeOff.table.columns.day"),
      dataIndex: "day",
      key: "day",
      sorter: (a, b) => a.day.localeCompare(b.day)
    },
    {
      title: t("crewMember.scheduledTimeOff.table.columns.dates"),
      dataIndex: "date",
      key: "date",
      sorter: (a, b) => new Date(a.date) - new Date(b.date)
    },
    {
      title: t("crewMember.scheduledTimeOff.table.columns.time"),
      dataIndex: "time",
      key: "time",
      sorter: (a, b) => a.time.localeCompare(b.time),
      render: (time) => {
        return (
          <Text>{time}</Text>
        )
      }
    },
    {
      title: t("crewMember.scheduledTimeOff.table.columns.type"),
      dataIndex: "entry_type",
      key: "entry_type",
      render: (entryType) => <EntryTypeTag entryType={entryType} />
    },
    {
      title: t("crewMember.scheduledTimeOff.table.columns.actions"),
      key: "actions",
      align: "right",
      width: 80,
      // Blackouts are edited from Blackout settings, which keeps every crew member in sync
      render: (_, record) => !isBlackout(record) && (
        <Dropdown
          trigger={["click"]}
          menu={{
            items: [
              {
                key: "edit",
                label: t("crewMember.scheduledTimeOff.table.actions.edit"),
                onClick: () => onEdit(record)
              },
              {
                key: "delete",
                label: t("crewMember.scheduledTimeOff.table.actions.delete"),
                danger: true,
                onClick: () => onDelete(record)
              }
            ]
          }}
          placement="bottomRight"
        >
          <Button type="text" icon={<MoreOutlined />} className={styles.moreButton} />
        </Dropdown>
      )
    }
  ]

  return columns
}

export default useScheduledTimeOffColumns
